module.exports = "<hybse-admin-company-edit [isDemo]=\"true\" [actionType]=\"'edit'\"></hybse-admin-company-edit>"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/update-demo-company/update-demo-company.component.html
// module id = ../../../../../src/app/components/pages/demo-company/update-demo-company/update-demo-company.component.html
// module chunks = main